<template>
  <div class="sports-page p404">
    <v-layout  class="page-layout">
      <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
        <resize-observer @notify="mainColumnResize" />
         <div class="staticcontent accpage">
          <h1>Sorry this page was not found</h1>
          <p>Go to <router-link :to="{ name: 'home'}">Homepage</router-link></p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>

import Screen from '@/components/mixins/Screen'
import store from '@/store'

export default {
  name: 'p404',
  data: () => ({
  }),

  mixins: [
    Screen
  ],

  computed: {
    headerHeight () {
      return store.getters['screenState/getHeaderHeight']
    },
    mainColumnWidth () {
      return store.getters['screenState/getMainColumnWidth']
    }
  },
  mounted () {
    this.mainColumnResize()
    window.scrollTo({ top: 0, behavior: 'smooth' })
  },

  methods: {
    mainColumnResize () {
      var mainColumn = this.$refs.maincolumn
      if (mainColumn) {
        store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.staticcontent.accpage
  text-align center
</style>



// WEBPACK FOOTER //
// src/components/common/errors/p404.vue